import HierarchyNotificationPayload from 'owa-service/lib/contract/HierarchyNotificationPayload';
import setBulkActionCounts from '../mutators/setBulkActionCounts';

export default function onBulkActionHierarchyNotification(payload: HierarchyNotificationPayload) {
    setBulkActionCounts(payload);
}
